import environment from '@/assets/img/definition/environment.png';
import economy from '@/assets/img/definition/economy.png';
import society from '@/assets/img/definition/society.png';

// Plain-text mirror of the intro sentence in Definition.jsx (which renders it
// with an inline <b> emphasis). Kept here too so the home page preview can
// quote the same definition without re-deriving it from JSX.
export const sustainabilityDefinition =
    'Sustainability is the capacity to maintain and balance environmental, ' +
    'economic, and social systems over the long term, ensuring that current ' +
    'needs are met without compromising the ability of future generations to ' +
    'meet their own needs.';

// Single source of truth for the three sustainability pillars so the About
// page's full Definition section and the home page's compact preview never
// drift apart on names or descriptions.
export const sustainabilityPillars = [
    {
        id: 'environment',
        title: 'Environment',
        description:
            'Environmental sustainability involves managing and conserving natural resources to ensure the health ' +
            'of ecosystems and mitigate adverse impacts on the environment.',
        imgSrc: environment,
    },
    {
        id: 'economy',
        title: 'Economy',
        description:
            'Economic sustainability entails maintaining a stable and resilient economic system that meets present ' +
            'needs while fostering long-term growth, prosperity, and distribution of resources.',
        imgSrc: economy,
    },
    {
        id: 'society',
        title: 'Society',
        description:
            'Social sustainability focuses on building resilient communities, ensuring access to resources ' +
            'and opportunities, and promoting the well-being and advancement of society for current and ' +
            'future generations.',
        imgSrc: society,
    },
];
